export default __webpack_public_path__ + "6c574c42d9462435a32ed2cfe17250a0.png";